import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Observable } from 'rxjs';

import { Environment } from '../../../environment';

import { LabResults } from '../models/overview.model';

@Injectable({
  providedIn: 'root',
})
export class OverviewService {
  protected readonly http = inject(HttpClient);
  private readonly env = inject(EnvironmentInjector) as Environment;

  protected baseUrl = this.env.APIM_BASE_URL + '/labresult-v2-service/labresult-v2/lab-results';

  getLabResults(keyword: string, pageNumber: number, pageSize: number): Observable<LabResults> {
    return this.http.get<LabResults>(
      `${this.baseUrl}?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&sortDirection=Desc`,
    );
  }

  getReport(id: number): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.baseUrl}/report/${id}`, {
      observe: 'response',
      responseType: 'blob',
    });
  }
}
